import type { ProvenanceDTO } from "@roomate/core";

/**
 * The Approach card on the Task page (docs/specs/decision-before-code.md, scope 4).
 *
 * The `approach` block mirrors the taskDetail field the hub adds for the decision gate. It is typed
 * here, optional and local, so this app typechecks before @roomate/core ships it. Delete the local
 * type once the core TaskDetail carries the real field.
 */
export type ApproachStatus = "not_required" | "missing" | "before_code" | "after_code";

export type ApproachDetail = {
  required: boolean;
  status: ApproachStatus;
  firstDecisionAt: number | null;
  firstCommitAt: number | null;
};

export type ApproachInput = {
  task: { builderId: string | null };
  provenance: ProvenanceDTO[];
  approach?: ApproachDetail | null;
};

export type ApproachCard = {
  status: ApproachStatus;
  /** The current builder's decisions, oldest first. Empty when the status is missing. */
  decisions: ProvenanceDTO[];
};

/** The card for a medium+ task, or null when the task has no Approach card (low risk, no-code, merge-resolve). */
export function approachCard(detail: ApproachInput): ApproachCard | null {
  const approach = detail.approach;
  if (!approach?.required) return null;
  if (approach.status === "missing") return { status: "missing", decisions: [] };
  const builder = detail.task.builderId;
  const decisions = detail.provenance.filter((p) => builder !== null && p.actorId === builder).sort((a, b) => a.createdAt - b.createdAt);
  return { status: approach.status, decisions };
}
